/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ViewTemplatesLibraryModalEntryPointEntrypointProps } from './ViewTemplatesLibraryModalEntryPoint.entrypoint.types.tsx';
import parameters, {
	type ViewTemplatesLibraryModalEntryPointQuery,
} from './__generated__/ViewTemplatesLibraryModalEntryPointQuery.graphql.ts';

type ViewTemplatesLibraryModalEntryPointPreloadParams = {
	cloudId: string;
	locale?: string;
};

type ModalEntryPointComponent = EntryPointComponent<
	{
		viewTemplatesQuery: ViewTemplatesLibraryModalEntryPointQuery;
	},
	Record<string, never>,
	ViewTemplatesLibraryModalEntryPointEntrypointProps,
	{}
>;

export const modalEntryPoint: EntryPoint<
	ModalEntryPointComponent,
	ViewTemplatesLibraryModalEntryPointPreloadParams
> = createEntryPoint({
	root: JSResourceForInteraction<ModalEntryPointComponent>(
		/* webpackChunkName: "async-polaris-component-view-templates-library-modal-entrypoint" */ './ViewTemplatesLibraryModalEntryPoint.tsx',
	),
	getPreloadProps: ({ cloudId, locale }: ViewTemplatesLibraryModalEntryPointPreloadParams) => {
		return {
			queries: {
				viewTemplatesQuery: {
					parameters,
					variables: {
						cloudId,
						...(locale ? { locale } : {}),
					},
				},
			},
		};
	},
});
